module.exports = __webpack_public_path__ + "img/battery-groupe-no-number-center.b17ba31d.svg";